angular.module('callX').controller('TOSCtrl', ['$scope', '$modalInstance', function($scope, $modalInstance) {

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}]);